import * as React from 'react';

require('../css/button.css');

interface Props
  extends React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    > {
  // Adding a property to add external css class. 
  buttonClassName?: string;
  
  disabled?: boolean;
  onClick(): void;
}

class Button extends React.Component<Props> {
  render() {
    let disabledClass = this.props.disabled ? ' disabled' : '';

    let className = `waves-effect waves-light btn${disabledClass}`;

    if (this.props.className) {
      className += ' ' + this.props.className;
    }
    // Check if external css properties comes from parent
    let buttonUserClass = this.props.buttonClassName === null ? '' : this.props.buttonClassName;

    return (
      <a
        {...this.props}
        className={`${className} ${buttonUserClass}`}
        onClick={e => this.props.onClick()}
      >
        {this.props.children}
      </a>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/Components/Button.tsx